export const mockTopics = [
  {
    id: '1',
    title: 'Sleep Apnea',
    category: 'Sleep Disorders',
    description: 'Learn about obstructive and central sleep apnea, symptoms, diagnosis, and treatment options including CPAP therapy.',
    shortDescription: 'Learn about obstructive and central sleep apnea, symptoms, diagnosis, and treatment options including CPAP therapy.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1584467735815-f778f274e296?w=800&q=80',
    content: 'Sleep apnea is a serious sleep disorder that occurs when breathing repeatedly stops and starts during sleep. The most common type is obstructive sleep apnea (OSA), which occurs when throat muscles intermittently relax and block the airway during sleep.',
    isPremium: true,
    premiumContent: {
      executiveSummary: 'Sleep apnea is a potentially serious sleep disorder where breathing repeatedly stops and starts during sleep. This comprehensive guide covers the types, symptoms, diagnosis, and evidence-based treatments including CPAP therapy, surgical options, and lifestyle modifications.',
      sections: [
        {
          title: 'Understanding Sleep Apnea',
          body: 'Sleep apnea is characterized by pauses in breathing or periods of shallow breathing during sleep. Each pause can last from a few seconds to several minutes and may occur hundreds of times per night. The most common type is obstructive sleep apnea (OSA), which occurs when the throat muscles intermittently relax and block the airway.'
        },
        {
          title: 'Types of Sleep Apnea',
          body: 'There are three main types: Obstructive Sleep Apnea (OSA) - the most common form caused by physical blockage of the airway; Central Sleep Apnea (CSA) - occurs when the brain fails to send proper signals to breathing muscles; and Mixed Sleep Apnea - a combination of both obstructive and central apnea.'
        },
        {
          title: 'Risk Factors and Causes',
          body: 'Major risk factors include excess weight, neck circumference over 17 inches in men or 16 inches in women, narrowed airway, being male, older age, family history, alcohol or sedative use, smoking, and nasal congestion. Anatomical factors such as enlarged tonsils or tongue position also contribute.'
        }
      ],
      caseStudy: 'A 52-year-old male patient presented with excessive daytime sleepiness, loud snoring, and witnessed apneas by his spouse. Sleep study revealed an AHI of 35 events/hour. After CPAP titration and adherence counseling, his symptoms improved dramatically within 3 weeks, and follow-up data showed AHI reduced to 2 events/hour.',
      examQuestion: {
        question: 'What is the gold standard diagnostic test for obstructive sleep apnea?',
        options: ['Home Sleep Apnea Test (HSAT)', 'Polysomnography (PSG)', 'Oximetry overnight', 'Clinical interview'],
        correctAnswer: 'Polysomnography (PSG)',
        explanation: 'While HSAT is useful for certain patients, in-laboratory polysomnography remains the gold standard for diagnosing sleep apnea as it provides comprehensive monitoring including EEG, EOG, EMG, respiratory effort, airflow, and oxygen saturation.'
      },
      videoScript: 'Welcome to this lesson on Sleep Apnea. Today we will explore what sleep apnea is, why it matters, and how we diagnose and treat it effectively...'
    },
    createdAt: '2024-01-15'
  },
  {
    id: '2',
    title: 'Insomnia',
    category: 'Sleep Disorders',
    description: 'Understanding chronic insomnia, causes, behavioral therapies, and evidence-based treatment approaches.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=800&q=80',
    content: 'Insomnia is a common sleep disorder characterized by difficulty falling asleep, staying asleep, or both. It can be acute (short-term) or chronic (long-term).',
    createdAt: '2024-01-16'
  },
  {
    id: '3',
    title: 'Sleep Hygiene',
    category: 'Sleep Health',
    description: 'Best practices for healthy sleep habits, bedroom environment optimization, and daily routines.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=800&q=80',
    content: 'Sleep hygiene refers to healthy sleep habits that can improve your ability to fall asleep and stay asleep. Good sleep hygiene practices include maintaining a consistent sleep schedule and creating a comfortable sleep environment.',
    createdAt: '2024-01-17'
  },
  {
    id: '4',
    title: 'CPAP Therapy',
    category: 'Treatment Devices',
    description: 'Complete guide to continuous positive airway pressure (CPAP) devices, masks, maintenance, and telemonitoring.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=800&q=80',
    content: 'CPAP therapy is the gold standard treatment for obstructive sleep apnea. It works by delivering a steady stream of pressurized air through a mask to keep airways open during sleep.',
    createdAt: '2024-01-18'
  },
  {
    id: '5',
    title: 'Narcolepsy',
    category: 'Sleep Disorders',
    description: 'Understanding narcolepsy symptoms, including excessive daytime sleepiness and cataplexy.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=800&q=80',
    content: 'Narcolepsy is a chronic neurological disorder that affects the brain\'s ability to control sleep-wake cycles. People with narcolepsy experience excessive daytime sleepiness and may have sudden attacks of sleep.',
    createdAt: '2024-01-19'
  },
  {
    id: '6',
    title: 'Restless Leg Syndrome',
    category: 'Sleep Disorders',
    description: 'Learn about RLS symptoms, triggers, and management strategies for better sleep quality.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80',
    content: 'Restless legs syndrome (RLS) is a condition that causes an uncontrollable urge to move the legs, usually due to uncomfortable sensations. It typically occurs in the evening or nighttime hours.',
    createdAt: '2024-01-20'
  },
  {
    id: '7',
    title: 'Circadian Rhythm',
    category: 'Sleep Science',
    description: 'Understanding your biological clock, shift work sleep disorder, and jet lag management.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1495364141860-b0d03eccd065?w=800&q=80',
    content: 'Circadian rhythm is your body\'s internal 24-hour clock that regulates sleep-wake cycles. Disruptions can lead to various sleep disorders and health issues.',
    createdAt: '2024-01-21'
  },
  {
    id: '8',
    title: 'Sleep Study (Polysomnography)',
    category: 'Diagnosis',
    description: 'What to expect during a sleep study, types of tests, and how results guide treatment.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80',
    content: 'Polysomnography, also called a sleep study, is a comprehensive test used to diagnose sleep disorders. It records brain waves, blood oxygen levels, heart rate, breathing, and eye and leg movements during sleep.',
    createdAt: '2024-01-22'
  },
  {
    id: '9',
    title: 'PLMS (Periodic Leg Movements)',
    category: 'Sleep Disorders',
    description: 'Learn about periodic limb movement disorder, its impact on sleep quality, and treatment options.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=800&q=80',
    content: 'Periodic Limb Movement Disorder (PLMD) involves repetitive cramping or jerking of the legs during sleep. These movements can significantly disrupt sleep quality and lead to daytime fatigue.',
    createdAt: '2024-01-23'
  },
  {
    id: '10',
    title: 'Sleep Paralysis',
    category: 'Sleep Disorders',
    description: 'Understanding sleep paralysis episodes, causes, triggers, and coping strategies.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1584438784894-089d6a62b8fa?w=800&q=80',
    content: 'Sleep paralysis is a temporary inability to move or speak while falling asleep or waking up. Episodes can be frightening but are generally harmless and often related to sleep deprivation or irregular sleep schedules.',
    createdAt: '2024-01-24'
  },
  {
    id: '11',
    title: 'Cataplexy',
    category: 'Symptoms',
    description: 'Recognizing cataplexy attacks, their relationship to narcolepsy, and management approaches.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&q=80',
    content: 'Cataplexy is a sudden, brief loss of voluntary muscle tone triggered by strong emotions. It is most commonly associated with narcolepsy and requires specialized treatment.',
    createdAt: '2024-01-25'
  },
  {
    id: '12',
    title: 'Fatigue and Sleep Disorders',
    category: 'Symptoms',
    description: 'Understanding chronic fatigue related to sleep disorders and strategies for energy management.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1551782450-17144efb9c50?w=800&q=80',
    content: 'Chronic fatigue is a common symptom of many sleep disorders. Understanding the underlying sleep issues is crucial for effective treatment and improved quality of life.',
    createdAt: '2024-01-26'
  },
  {
    id: '13',
    title: 'Sleep Stages',
    category: 'Sleep Science',
    description: 'Explore the four stages of sleep, REM cycles, and their importance for health and recovery.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=80',
    content: 'Sleep consists of multiple stages including light sleep (N1, N2), deep sleep (N3), and REM sleep. Each stage plays a vital role in physical restoration, memory consolidation, and overall health.',
    createdAt: '2024-01-27'
  },
  {
    id: '14',
    title: 'Central Sleep Apnea',
    category: 'Sleep Disorders',
    description: 'Understanding central apneas, differences from obstructive apnea, and specialized treatments.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=800&q=80',
    content: 'Central sleep apnea occurs when the brain fails to send proper signals to breathing muscles. Unlike obstructive sleep apnea, there is no physical blockage of the airway.',
    createdAt: '2024-01-28'
  },
  {
    id: '15',
    title: 'BiPAP Therapy',
    category: 'Treatment Devices',
    description: 'Learn about bilevel positive airway pressure (BiPAP) devices and when they are prescribed.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1581594549595-35f6edc7b762?w=800&q=80',
    content: 'BiPAP provides two levels of pressure - higher pressure during inhalation and lower during exhalation. It is often prescribed for patients who have difficulty tolerating CPAP or have certain breathing conditions.',
    createdAt: '2024-01-29'
  },
  {
    id: '16',
    title: 'BiPAP ST (Spontaneous/Timed)',
    category: 'Treatment Devices',
    description: 'Advanced BiPAP ST mode for patients with complex breathing patterns and central apneas.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1581092918484-8313e1f7e8e1?w=800&q=80',
    content: 'BiPAP ST provides backup breathing support when spontaneous breaths are not detected. This mode is essential for patients with hypoventilation or central sleep apnea.',
    createdAt: '2024-01-30'
  },
  {
    id: '17',
    title: 'Auto Servo-Ventilation (ASV)',
    category: 'Treatment Devices',
    description: 'Understanding ASV therapy for complex sleep apnea and Cheyne-Stokes respiration.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1579154204601-01588f351e67?w=800&q=80',
    content: 'ASV is an advanced ventilation therapy that adjusts pressure support breath-by-breath. It is specifically designed for central sleep apnea and complex sleep apnea syndrome.',
    createdAt: '2024-02-01'
  },
  {
    id: '18',
    title: 'PAP Treatment Techniques',
    category: 'Treatments',
    description: 'Practical tips for successful PAP therapy, troubleshooting, and maximizing compliance.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    content: 'Success with PAP therapy requires proper mask fitting, gradual acclimation, and addressing common challenges like dry mouth, mask leaks, and claustrophobia.',
    createdAt: '2024-02-02'
  },
  {
    id: '19',
    title: 'Daytime CPAP Practice',
    category: 'Treatments',
    description: 'Strategies for getting comfortable with CPAP therapy through daytime practice sessions.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=800&q=80',
    content: 'Practicing with your CPAP while awake helps build comfort and confidence. Start with short sessions while watching TV or reading to gradually acclimate to the mask and pressure.',
    createdAt: '2024-02-03'
  },
  {
    id: '20',
    title: 'Sleep Apnea Treatment Alternatives',
    category: 'Treatments',
    description: 'Explore alternative treatments including oral appliances, positional therapy, and surgical options.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1579154204601-01588f351e67?w=800&q=80',
    content: 'While CPAP is the gold standard, alternatives exist including mandibular advancement devices, positional therapy for positional sleep apnea, weight loss programs, and surgical interventions.',
    createdAt: '2024-02-04'
  },
  {
    id: '21',
    title: 'Cardiovascular Effects of Sleep Apnea',
    category: 'Complications',
    description: 'Understanding the serious cardiovascular risks associated with untreated sleep apnea.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=800&q=80',
    content: 'Untreated sleep apnea significantly increases the risk of hypertension, heart attack, stroke, atrial fibrillation, and heart failure. Treatment can reduce these cardiovascular risks.',
    createdAt: '2024-02-05'
  },
  {
    id: '22',
    title: 'Erectile Dysfunction and Sleep Apnea',
    category: 'Complications',
    description: 'The connection between sleep apnea and erectile dysfunction, and how treatment helps.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80',
    content: 'Sleep apnea is strongly linked to erectile dysfunction due to reduced oxygen levels, hormonal changes, and cardiovascular effects. CPAP therapy often improves sexual function.',
    createdAt: '2024-02-06'
  },
  {
    id: '23',
    title: 'Low Libido and Sleep Disorders',
    category: 'Complications',
    description: 'How sleep disorders affect sexual desire and intimate relationships.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1516307365426-bea591f05011?w=800&q=80',
    content: 'Poor sleep quality from sleep disorders leads to decreased libido through multiple mechanisms including fatigue, hormonal imbalances, and mood changes. Treating the underlying sleep disorder often restores sexual desire.',
    createdAt: '2024-02-07'
  },
  {
    id: '24',
    title: 'Sleep Apnea Main Symptoms',
    category: 'Symptoms',
    description: 'Recognizing the key warning signs and symptoms of sleep apnea for early diagnosis.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=800&q=80',
    content: 'Main symptoms include loud snoring, witnessed breathing pauses, gasping or choking during sleep, excessive daytime sleepiness, morning headaches, difficulty concentrating, and irritability.',
    createdAt: '2024-02-08'
  },
  {
    id: '25',
    title: 'Sleep in Women',
    category: 'Women\'s Health',
    description: 'Understanding unique sleep challenges women face throughout their lives and hormonal changes.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80',
    content: 'Women experience unique sleep challenges due to hormonal fluctuations, pregnancy, menopause, and other life stages. Understanding these factors helps address sleep issues effectively.',
    createdAt: '2024-02-09'
  },
  {
    id: '26',
    title: 'Sleep in Infants',
    category: 'Pediatric Sleep',
    description: 'Essential information about infant sleep patterns, safe sleep practices, and developmental stages.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1555252333-9f8e92e65df9?w=800&q=80',
    content: 'Infant sleep is characterized by shorter sleep cycles and frequent waking for feeding. Safe sleep practices are crucial to reduce SIDS risk.',
    createdAt: '2024-02-10'
  },
  {
    id: '27',
    title: 'Sleep in Children',
    category: 'Pediatric Sleep',
    description: 'Age-appropriate sleep needs, common childhood sleep problems, and healthy sleep habits.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&q=80',
    content: 'Children require more sleep than adults for proper growth and development. Establishing consistent bedtime routines is essential for healthy sleep habits.',
    createdAt: '2024-02-11'
  },
  {
    id: '28',
    title: 'Sleep and Menstruation',
    category: 'Women\'s Health',
    description: 'How menstrual cycles affect sleep quality and strategies for better rest during your period.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80',
    content: 'Hormonal changes during the menstrual cycle can significantly impact sleep quality, causing insomnia, increased sleepiness, or sleep disturbances.',
    createdAt: '2024-02-12'
  },
  {
    id: '29',
    title: 'Sleep and Pregnancy',
    category: 'Women\'s Health',
    description: 'Sleep challenges during pregnancy and safe sleeping positions for expectant mothers.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1493101561740-e745892775b2?w=800&q=80',
    content: 'Pregnancy brings unique sleep challenges including discomfort, frequent urination, and hormonal changes. Side sleeping, particularly on the left side, is recommended.',
    createdAt: '2024-02-13'
  },
  {
    id: '30',
    title: 'Sleep and Stress',
    category: 'Lifestyle & Sleep',
    description: 'The bidirectional relationship between stress and sleep, plus relaxation techniques.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=800&q=80',
    content: 'Stress and sleep have a complex relationship where each affects the other. Managing stress through relaxation techniques improves sleep quality.',
    createdAt: '2024-02-14'
  },
  {
    id: '31',
    title: 'First Time PAP User Education',
    category: 'Treatments',
    description: 'Comprehensive guide for new PAP therapy users to ensure successful treatment adaptation.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80',
    content: 'Starting PAP therapy can be challenging. This guide covers setup, mask fitting, pressure acclimation, and troubleshooting common first-time user issues.',
    createdAt: '2024-02-15'
  },
  {
    id: '32',
    title: 'Cleansing Your Sleep Device',
    category: 'Device Maintenance',
    description: 'Proper cleaning and maintenance procedures for CPAP, BiPAP, and other sleep therapy devices.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=800&q=80',
    content: 'Regular cleaning of your PAP equipment is essential for hygiene and device longevity. Daily and weekly cleaning routines ensure optimal therapy.',
    createdAt: '2024-02-16'
  },
  {
    id: '33',
    title: 'Mandibular Advancement Device',
    category: 'Treatment Devices',
    description: 'Oral appliances for sleep apnea treatment as an alternative to CPAP therapy.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=800&q=80',
    content: 'Mandibular advancement devices (MAD) reposition the lower jaw forward to keep airways open during sleep. Effective for mild to moderate OSA.',
    createdAt: '2024-02-17'
  },
  {
    id: '34',
    title: 'Excite OSA',
    category: 'Treatment Devices',
    description: 'Hypoglossal nerve stimulation therapy as an innovative treatment for obstructive sleep apnea.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=800&q=80',
    content: 'Excite OSA and similar hypoglossal nerve stimulation systems offer an alternative for patients who cannot tolerate PAP therapy.',
    createdAt: '2024-02-18'
  },
  {
    id: '35',
    title: 'Bruxism and Nightguards',
    category: 'Sleep Disorders',
    description: 'Understanding teeth grinding during sleep and protective nightguard solutions.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1609840114035-3c981407e1b8?w=800&q=80',
    content: 'Bruxism (teeth grinding) can damage teeth and cause jaw pain. Custom nightguards protect teeth and may reduce grinding intensity.',
    createdAt: '2024-02-19'
  },
  {
    id: '36',
    title: 'Causes of Bruxism',
    category: 'Sleep Disorders',
    description: 'Exploring the underlying causes and triggers of sleep-related teeth grinding.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=800&q=80',
    content: 'Bruxism causes include stress, anxiety, sleep disorders, medications, and anatomical factors. Identifying the cause helps target treatment.',
    createdAt: '2024-02-20'
  },
  {
    id: '37',
    title: 'Good and Bad Sleep Hygiene',
    category: 'Sleep Health',
    description: 'Comparing beneficial sleep practices with habits that harm sleep quality.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=800&q=80',
    content: 'Good sleep hygiene includes consistent schedules, cool dark rooms, and avoiding screens before bed. Bad habits like irregular schedules and caffeine disrupt sleep.',
    createdAt: '2024-02-21'
  },
  {
    id: '38',
    title: 'Sleep Talking (Somniloquy)',
    category: 'Parasomnias',
    description: 'Understanding sleep talking episodes, causes, and whether treatment is necessary.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1520206319821-0496cfdeb31e?w=800&q=80',
    content: 'Sleep talking is usually harmless and occurs during transitions between sleep stages. It is more common during stress or sleep deprivation.',
    createdAt: '2024-02-22'
  },
  {
    id: '39',
    title: 'Somnambulism (Sleepwalking)',
    category: 'Parasomnias',
    description: 'Causes, safety concerns, and management of sleepwalking episodes.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1582560469781-1965b9af903d?w=800&q=80',
    content: 'Sleepwalking occurs during deep sleep stages. Safety measures and addressing underlying causes like sleep deprivation are important.',
    createdAt: '2024-02-23'
  },
  {
    id: '40',
    title: 'Parasomnias Overview',
    category: 'Parasomnias',
    description: 'Comprehensive guide to abnormal behaviors occurring during sleep.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1584438784894-089d6a62b8fa?w=800&q=80',
    content: 'Parasomnias are abnormal sleep behaviors including sleepwalking, night terrors, REM sleep behavior disorder, and sleep paralysis.',
    createdAt: '2024-02-24'
  },
  {
    id: '41',
    title: 'Night Terrors',
    category: 'Parasomnias',
    description: 'Understanding night terrors in children and adults, and how to respond appropriately.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1519155031214-e8d583928bf2?w=800&q=80',
    content: 'Night terrors involve intense fear during deep sleep with no memory of the episode. Common in children, they usually resolve with age.',
    createdAt: '2024-02-25'
  },
  {
    id: '42',
    title: 'Nightmares',
    category: 'Parasomnias',
    description: 'Causes of frequent nightmares and strategies for reducing their occurrence.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1541199249251-f713e6145474?w=800&q=80',
    content: 'Nightmares occur during REM sleep and are remembered upon waking. Stress, trauma, medications, and sleep disorders can increase nightmare frequency.',
    createdAt: '2024-02-26'
  },
  {
    id: '43',
    title: 'PTSD and Sleep',
    category: 'Lifestyle & Sleep',
    description: 'The relationship between post-traumatic stress disorder and sleep disturbances.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1527689368864-3a821dbccc34?w=800&q=80',
    content: 'PTSD significantly affects sleep through nightmares, insomnia, and hyperarousal. Treatment addressing both PTSD and sleep is most effective.',
    createdAt: '2024-02-27'
  },
  {
    id: '44',
    title: 'Concussion and Central Apnea',
    category: 'Sleep Disorders',
    description: 'Understanding the link between traumatic brain injury and central sleep apnea.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=800&q=80',
    content: 'Traumatic brain injuries can disrupt breathing control centers, leading to central sleep apnea. Screening after concussion is important.',
    createdAt: '2024-02-28'
  },
  {
    id: '45',
    title: 'Sleep Stages Identification',
    category: 'Sleep Science',
    description: 'How sleep stages are identified and measured during polysomnography.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
    content: 'Sleep stages are identified through EEG, eye movements, and muscle activity. Each stage has distinct characteristics visible in sleep study data.',
    createdAt: '2024-03-01'
  },
  {
    id: '46',
    title: 'Sleep Stages Normal Time Distribution',
    category: 'Sleep Science',
    description: 'Understanding how much time should be spent in each sleep stage for healthy sleep.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1509023464722-18d996393ca8?w=800&q=80',
    content: 'Normal adults spend approximately 50% in light sleep, 20% in deep sleep, and 25% in REM sleep. These percentages vary by age.',
    createdAt: '2024-03-02'
  },
  {
    id: '47',
    title: 'Sleep Fragmentation',
    category: 'Sleep Disorders',
    description: 'Causes and consequences of disrupted, non-continuous sleep patterns.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1551782450-17144efb9c50?w=800&q=80',
    content: 'Sleep fragmentation results from frequent arousals that prevent deep, restorative sleep. Common causes include sleep apnea, PLMD, and environmental factors.',
    createdAt: '2024-03-03'
  },
  {
    id: '48',
    title: 'Pediatric Sleep Conditions',
    category: 'Pediatric Sleep',
    description: 'Common sleep disorders affecting children and adolescents.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&q=80',
    content: 'Children can experience sleep apnea, insomnia, restless legs syndrome, and parasomnias. Early recognition and treatment are crucial for development.',
    createdAt: '2024-03-04'
  },
  {
    id: '49',
    title: 'Sleep Study Procedure Explained',
    category: 'Diagnosis',
    description: 'Step-by-step walkthrough of what happens during an overnight sleep study.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800&q=80',
    content: 'Sleep studies involve sensor placement, overnight monitoring in a comfortable room, and comprehensive data collection to diagnose sleep disorders.',
    createdAt: '2024-03-05'
  },
  {
    id: '50',
    title: 'Sexsomnia',
    category: 'Parasomnias',
    description: 'Understanding sleep-related sexual behaviors and their management.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1520206319821-0496cfdeb31e?w=800&q=80',
    content: 'Sexsomnia involves sexual behaviors during sleep with no conscious awareness. Treatment focuses on sleep quality improvement and safety.',
    createdAt: '2024-03-06'
  },
  {
    id: '51',
    title: 'Exposure to Light and Sleep',
    category: 'Lifestyle & Sleep',
    description: 'How light exposure affects circadian rhythms and sleep-wake cycles.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1495364141860-b0d03eccd065?w=800&q=80',
    content: 'Light is the primary circadian rhythm regulator. Blue light from screens suppresses melatonin, while morning light exposure promotes alertness.',
    createdAt: '2024-03-07'
  },
  {
    id: '52',
    title: 'Sleep Preparation Routine',
    category: 'Sleep Health',
    description: 'Creating an effective wind-down routine for better sleep onset.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800&q=80',
    content: 'A consistent pre-sleep routine signals your body it is time to sleep. Include relaxation techniques, dimming lights, and avoiding stimulating activities.',
    createdAt: '2024-03-08'
  },
  {
    id: '53',
    title: 'Obesity and Sleep',
    category: 'Lifestyle & Sleep',
    description: 'The bidirectional relationship between obesity and sleep disorders.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=800&q=80',
    content: 'Obesity increases sleep apnea risk, while poor sleep promotes weight gain through hormonal changes affecting appetite and metabolism.',
    createdAt: '2024-03-09'
  },
  {
    id: '54',
    title: 'Nutrition and Sleep',
    category: 'Lifestyle & Sleep',
    description: 'How diet and meal timing affect sleep quality and duration.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&q=80',
    content: 'Certain nutrients promote sleep while others disrupt it. Meal timing, caffeine intake, and specific foods can significantly impact sleep quality.',
    createdAt: '2024-03-10'
  },
  {
    id: '55',
    title: 'Menopause and Sleep',
    category: 'Women\'s Health',
    description: 'Understanding sleep disruptions during menopause and effective management strategies.',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    imageUrl: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80',
    content: 'Menopause causes significant sleep disruptions through hot flashes, night sweats, and hormonal changes. Understanding these changes helps in managing sleep issues during this transition.',
    createdAt: '2024-03-11'
  },
  
  // Additional Neuroscience Topics (56-70)
  {
    id: '56',
    title: 'Brain Dreams Under Stress',
    category: 'Neuroscience Fundamentals',
    description: 'Why the brain dreams more intensely under stress.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1617791160505-6f00504e3519?w=800&q=80',
    content: 'Stress increases REM sleep intensity and dream vividness as the brain processes emotional experiences and threats.',
    createdAt: '2024-03-12'
  },
  {
    id: '57',
    title: 'Sleep Spindles: What They Are',
    category: 'Neuroscience Fundamentals',
    description: 'Understanding sleep spindles and why they matter for memory.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800&q=80',
    content: 'Sleep spindles are bursts of brain activity during Stage 2 sleep that play a crucial role in memory consolidation and learning.',
    createdAt: '2024-03-13'
  },
  {
    id: '58',
    title: 'REM Sleep and Emotional Regulation',
    category: 'Neuroscience Fundamentals',
    description: 'How REM sleep improves emotional regulation.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1507413245164-6160d8298b31?w=800&q=80',
    content: 'REM sleep helps process emotional memories, reducing their emotional charge and improving mood regulation.',
    createdAt: '2024-03-14'
  },
  {
    id: '59',
    title: 'Sleep Deprivation Mimics Aging',
    category: 'Aging & Brain Health',
    description: 'Why sleep deprivation mimics aging in the brain.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&q=80',
    content: 'Chronic sleep deprivation accelerates cognitive decline and shares many characteristics with brain aging.',
    createdAt: '2024-03-15'
  },
  {
    id: '60',
    title: 'Sleep, Creativity and Problem Solving',
    category: 'Neuroscience Fundamentals',
    description: 'The role of sleep in creativity and problem solving.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1516714819001-8ee7a13b71d7?w=800&q=80',
    content: 'Sleep enhances creative thinking and problem-solving by allowing the brain to form novel connections between ideas.',
    createdAt: '2024-03-16'
  },
  {
    id: '61',
    title: 'Synaptic Pruning During Sleep',
    category: 'Neuroscience Fundamentals',
    description: 'The brain deletes unnecessary connections at night.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&q=80',
    content: 'During sleep, the brain strengthens important synapses while pruning unnecessary ones, optimizing neural networks.',
    createdAt: '2024-03-17'
  },
  {
    id: '62',
    title: 'Night Owls: Genetics vs Environment',
    category: 'Neuroscience Fundamentals',
    description: 'Why some people are night owls - genetics vs environment.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1502139214982-d0ad755818d8?w=800&q=80',
    content: 'Chronotype is influenced by both genetic factors and environmental conditioning, affecting natural sleep-wake preferences.',
    createdAt: '2024-03-18'
  },
  {
    id: '63',
    title: 'The Neuroscience of Nightmares',
    category: 'Parasomnias',
    description: 'Understanding nightmares from a neuroscience perspective.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1541199249251-f713e6145474?w=800&q=80',
    content: 'Nightmares involve amygdala hyperactivity during REM sleep, often triggered by stress, trauma, or medications.',
    createdAt: '2024-03-19'
  },
  {
    id: '64',
    title: 'Psychedelics and REM Sleep',
    category: 'Controversial Topics',
    description: 'What psychedelics and REM sleep have in common.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1551782450-17144efb9c50?w=800&q=80',
    content: 'Both psychedelics and REM sleep show increased brain network connectivity and reduced default mode network activity.',
    createdAt: '2024-03-20'
  },
  {
    id: '65',
    title: 'Brain Waves Explained',
    category: 'Neuroscience Fundamentals',
    description: 'Delta, theta, alpha, beta, and gamma waves explained.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1507413245164-6160d8298b31?w=800&q=80',
    content: 'Different brain wave frequencies correspond to different states of consciousness, from deep sleep (delta) to active thinking (gamma).',
    createdAt: '2024-03-21'
  },
  
  // Sleep Disorders Deep Dives (66-75)
  {
    id: '66',
    title: 'Hypoventilation Syndromes',
    category: 'Sleep Disorders Deep Dive',
    description: 'Understanding sleep-related hypoventilation disorders.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=800&q=80',
    content: 'Sleep-related hypoventilation occurs when breathing becomes too shallow or slow during sleep, leading to elevated CO2 levels.',
    createdAt: '2024-03-22'
  },
  {
    id: '67',
    title: 'Fatal Familial Insomnia',
    category: 'Sleep Disorders Deep Dive',
    description: 'Prion-based neurological disease affecting sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&q=80',
    content: 'Fatal familial insomnia is a rare genetic prion disease that progressively destroys the thalamus, eliminating the ability to sleep.',
    createdAt: '2024-03-23'
  },
  {
    id: '68',
    title: 'Sleep-Related Epilepsy',
    category: 'Sleep Disorders Deep Dive',
    description: 'EEG patterns and triggers in sleep-related seizures.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80',
    content: 'Certain types of epilepsy are triggered or worsened by sleep transitions, requiring specialized monitoring and treatment.',
    createdAt: '2024-03-24'
  },
  {
    id: '69',
    title: 'Jet Lag and SCN Misalignment',
    category: 'Sleep Disorders Deep Dive',
    description: 'Suprachiasmatic nucleus misalignment explained.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1495364141860-b0d03eccd065?w=800&q=80',
    content: 'Jet lag occurs when the suprachiasmatic nucleus cannot quickly adjust to new time zones, causing temporary circadian disruption.',
    createdAt: '2024-03-25'
  },
  {
    id: '70',
    title: 'Shift Work Disorder',
    category: 'Sleep Disorders Deep Dive',
    description: 'Consequences to the brain from irregular schedules.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1551782450-17144efb9c50?w=800&q=80',
    content: 'Shift work disorder disrupts circadian rhythms, leading to chronic sleep deprivation, metabolic issues, and increased health risks.',
    createdAt: '2024-03-26'
  },
  {
    id: '71',
    title: 'CPAP Compliance Science',
    category: 'Treatment Devices',
    description: 'How habit and reward rewire behavior for CPAP use.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
    content: 'CPAP compliance improves through behavioral reinforcement, gradual habituation, and experiencing positive health outcomes.',
    createdAt: '2024-03-27'
  },
  
  // Aging & Brain Health (72-78)
  {
    id: '72',
    title: 'Sleep Decline with Age',
    category: 'Aging & Brain Health',
    description: 'Why sleep quality decreases as we age.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80',
    content: 'Aging reduces deep sleep and increases nighttime awakenings due to changes in circadian rhythms and neurotransmitter systems.',
    createdAt: '2024-03-28'
  },
  {
    id: '73',
    title: 'Sleep and Alzheimer\'s Disease',
    category: 'Aging & Brain Health',
    description: 'Amyloid clearance and Alzheimer\'s risk.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&q=80',
    content: 'Poor sleep impairs amyloid-beta clearance through the glymphatic system, potentially increasing Alzheimer\'s disease risk.',
    createdAt: '2024-03-29'
  },
  {
    id: '74',
    title: 'Sleep and Parkinson\'s Disease',
    category: 'Aging & Brain Health',
    description: 'REM behavior disorder as an early predictor.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=800&q=80',
    content: 'REM sleep behavior disorder can precede Parkinson\'s disease by years, serving as an important early warning sign.',
    createdAt: '2024-03-30'
  },
  {
    id: '75',
    title: 'Sleep and Dementia Risk',
    category: 'Aging & Brain Health',
    description: 'How sleep quality affects cognitive decline.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=80',
    content: 'Chronic poor sleep increases dementia risk through multiple mechanisms including impaired waste clearance and neuroinflammation.',
    createdAt: '2024-03-31'
  },
  {
    id: '76',
    title: 'Can Sleep Reverse Biological Aging?',
    category: 'Aging & Brain Health',
    description: 'Sleep\'s role in longevity and biological age.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=800&q=80',
    content: 'Quality sleep may slow biological aging by reducing oxidative stress, inflammation, and cellular damage.',
    createdAt: '2024-04-01'
  },
  {
    id: '77',
    title: 'Melatonin Production Over Lifespan',
    category: 'Aging & Brain Health',
    description: 'How melatonin levels change with age.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1495364141860-b0d03eccd065?w=800&q=80',
    content: 'Melatonin production peaks in childhood and gradually declines with age, contributing to sleep difficulties in older adults.',
    createdAt: '2024-04-02'
  },
  {
    id: '78',
    title: 'Sleep, Mortality and Longevity',
    category: 'Aging & Brain Health',
    description: 'The relationship between sleep duration and lifespan.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1551782450-17144efb9c50?w=800&q=80',
    content: 'Both insufficient and excessive sleep are associated with increased mortality risk, with 7-8 hours being optimal.',
    createdAt: '2024-04-03'
  },
  
  // Controversial & Viral Topics (79-88)
  {
    id: '79',
    title: 'Dream Telepathy: Science vs Myth',
    category: 'Controversial Topics',
    description: 'Scientific and mythological perspectives on shared dreams.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1551782450-17144efb9c50?w=800&q=80',
    content: 'While anecdotal reports exist, scientific evidence for dream telepathy remains elusive despite decades of parapsychology research.',
    createdAt: '2024-04-04'
  },
  {
    id: '80',
    title: 'Learning Languages While Asleep',
    category: 'Controversial Topics',
    description: 'The science behind sleep learning and its limitations.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1515894203077-9cd36032d3a4?w=800&q=80',
    content: 'While complete language learning during sleep is impossible, research shows we can strengthen existing knowledge during certain sleep stages.',
    createdAt: '2024-04-05'
  },
  {
    id: '81',
    title: 'Lucid Dreaming: Neurology vs Mysticism',
    category: 'Controversial Topics',
    description: 'Scientific understanding of conscious control in dreams.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=800&q=80',
    content: 'Lucid dreaming involves metacognitive awareness during REM sleep, with measurable brain activity patterns distinct from normal dreaming.',
    createdAt: '2024-04-06'
  },
  {
    id: '82',
    title: 'Sleep Deprivation Hallucinations',
    category: 'Controversial Topics',
    description: 'What happens to the brain after extreme sleep loss.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=800&q=80',
    content: 'Severe sleep deprivation can cause hallucinations, delusions, and psychosis-like symptoms due to REM sleep intrusion into wakefulness.',
    createdAt: '2024-04-07'
  },
  {
    id: '83',
    title: 'Sleep in Extreme Environments',
    category: 'Controversial Topics',
    description: 'Antarctica, submarines, and space sleep challenges.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80',
    content: 'Extreme environments disrupt circadian rhythms through altered light exposure, confined spaces, and psychological stress.',
    createdAt: '2024-04-08'
  },
  {
    id: '84',
    title: 'Military Sleep Performance',
    category: 'Sleep & Performance',
    description: 'Navy SEAL sleep engineering and optimization.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&q=80',
    content: 'Military sleep training focuses on maximizing recovery during short sleep windows and maintaining performance under extreme deprivation.',
    createdAt: '2024-04-09'
  },
  {
    id: '85',
    title: 'Controlling Dreams with Technology',
    category: 'Controversial Topics',
    description: 'Brain-computer interfaces and dream manipulation.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=800&q=80',
    content: 'Emerging technologies including targeted memory reactivation and sensory cues show promise in influencing dream content.',
    createdAt: '2024-04-10'
  },
  {
    id: '86',
    title: 'AI and Sleep: The Future',
    category: 'Sleep Technologies',
    description: 'Brain-computer interface future for sleep optimization.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=800&q=80',
    content: 'AI-powered sleep analysis and optimization may revolutionize personalized sleep medicine through real-time monitoring and intervention.',
    createdAt: '2024-04-11'
  },
  {
    id: '87',
    title: 'Near-Death Experiences: REM Theory',
    category: 'Controversial Topics',
    description: 'REM intrusion hypothesis for NDEs.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1551782450-17144efb9c50?w=800&q=80',
    content: 'Some researchers propose near-death experiences may result from REM sleep mechanisms activating during extreme physiological stress.',
    createdAt: '2024-04-12'
  },
  
  // Additional Categories (88-92)
  {
    id: '88',
    title: 'Biphasic and Segmented Sleep History',
    category: 'Cultural & Historical',
    description: 'How ancient civilizations approached sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=800&q=80',
    content: 'Historical evidence suggests pre-industrial humans practiced segmented sleep with two distinct sleep periods each night.',
    createdAt: '2024-04-13'
  },
  {
    id: '89',
    title: 'Sleep Myths Across Cultures',
    category: 'Cultural & Historical',
    description: 'Cultural beliefs and practices around sleep worldwide.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1495364141860-b0d03eccd065?w=800&q=80',
    content: 'Different cultures have developed unique sleep myths, rituals, and practices reflecting their environmental and social contexts.',
    createdAt: '2024-04-14'
  },
  {
    id: '90',
    title: 'Consumer Sleep Trackers vs Clinical PSG',
    category: 'Sleep Technologies',
    description: 'Comparing wearable devices to medical-grade sleep studies.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    content: 'Consumer sleep trackers provide useful estimates but cannot match the accuracy and diagnostic capability of clinical polysomnography.',
    createdAt: '2024-04-15'
  },
  {
    id: '91',
    title: 'AI in Polysomnography',
    category: 'Sleep Technologies',
    description: 'Artificial intelligence transforming sleep study analysis.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=800&q=80',
    content: 'AI algorithms are improving sleep stage scoring accuracy and reducing analysis time for polysomnography studies.',
    createdAt: '2024-04-16'
  },
  {
    id: '92',
    title: 'Future of Brain Stimulation During Sleep',
    category: 'Sleep Technologies',
    description: 'Emerging technologies for sleep enhancement.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    content: 'Transcranial electrical and magnetic stimulation may enhance sleep quality and memory consolidation through targeted brain stimulation.',
    createdAt: '2024-04-17'
  },
  
  // New Topics Added from 92-Topic List
  {
    id: '93',
    title: 'What Is Sleep?',
    category: 'Sleep Science',
    description: 'A fundamental introduction to the biological process of sleep and its essential role in human health.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=800&q=80',
    content: 'Sleep is a naturally recurring state of altered consciousness characterized by reduced sensory activity and inhibited voluntary muscles.',
    createdAt: '2024-04-18'
  },
  {
    id: '94',
    title: 'Why Do We Sleep?',
    category: 'Sleep Science',
    description: 'Exploring the evolutionary and biological reasons behind our need for sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=800&q=80',
    content: 'Sleep serves multiple vital functions including memory consolidation, cellular repair, immune function, and metabolic regulation.',
    createdAt: '2024-04-19'
  },
  {
    id: '95',
    title: 'Homeostatic Sleep Drive',
    category: 'Sleep Science',
    description: 'Understanding the internal pressure to sleep that builds throughout the day.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1581594549595-35f6edc7b762?w=800&q=80',
    content: 'Sleep pressure accumulates with prolonged wakefulness through adenosine buildup, creating the drive to sleep.',
    createdAt: '2024-04-20'
  },
  {
    id: '96',
    title: 'Sleep Architecture Overview',
    category: 'Sleep Science',
    description: 'Comprehensive look at the structural organization of sleep cycles throughout the night.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80',
    content: 'Sleep architecture refers to the cyclical pattern of sleep stages that repeat approximately every 90 minutes throughout the night.',
    createdAt: '2024-04-21'
  },
  {
    id: '97',
    title: 'Sleep Across the Lifespan',
    category: 'Sleep Science',
    description: 'How sleep needs and patterns change from infancy through old age.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80',
    content: 'Sleep requirements and architecture evolve dramatically across the lifespan, from polyphasic infant sleep to fragmented elderly sleep.',
    createdAt: '2024-04-22'
  },
  {
    id: '98',
    title: 'Sleep and Memory Consolidation',
    category: 'Sleep Science',
    description: 'The critical role of sleep in forming and strengthening memories.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800&q=80',
    content: 'Sleep facilitates memory consolidation through synaptic strengthening during slow-wave sleep and memory integration during REM sleep.',
    createdAt: '2024-04-23'
  },
  {
    id: '99',
    title: 'Sleep and Hormones',
    category: 'Sleep Science',
    description: 'How sleep regulates hormone production and the impact on overall health.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    content: 'Sleep profoundly influences hormones including growth hormone, cortisol, insulin, leptin, and ghrelin, affecting metabolism and stress.',
    createdAt: '2024-04-24'
  },
  {
    id: '100',
    title: 'Sleep and Immune Function',
    category: 'Sleep Science',
    description: 'The bidirectional relationship between sleep and the immune system.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576671081837-49000212a370?w=800&q=80',
    content: 'Quality sleep strengthens immune function through cytokine production and T-cell activity, while poor sleep increases infection susceptibility.',
    createdAt: '2024-04-25'
  },
  {
    id: '101',
    title: 'Sleep Deprivation Effects',
    category: 'Sleep Science',
    description: 'The wide-ranging consequences of insufficient sleep on mind and body.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1551782450-17144efb9c50?w=800&q=80',
    content: 'Sleep deprivation impairs cognitive function, mood regulation, immune response, and increases risks of chronic diseases.',
    createdAt: '2024-04-26'
  },
  {
    id: '102',
    title: 'Dreams and REM Physiology',
    category: 'Sleep Science',
    description: 'The neuroscience behind dreaming and REM sleep mechanisms.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1541199249251-f713e6145474?w=800&q=80',
    content: 'Dreams primarily occur during REM sleep when brain activity is high but voluntary muscle control is inhibited.',
    createdAt: '2024-04-27'
  },
  {
    id: '103',
    title: 'Mixed Sleep Apnea',
    category: 'Sleep Disorders',
    description: 'Understanding the combination of obstructive and central apneas in one patient.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1581089781785-603411fa81e5?w=800&q=80',
    content: 'Mixed sleep apnea features both obstructive airway collapse and central respiratory control dysfunction requiring specialized treatment.',
    createdAt: '2024-04-28'
  },
  {
    id: '104',
    title: 'Upper Airway Resistance Syndrome (UARS)',
    category: 'Sleep Disorders',
    description: 'A sleep-related breathing disorder characterized by airway narrowing without complete apneas.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=800&q=80',
    content: 'UARS causes frequent arousals due to increased breathing effort from airway resistance, often missed by standard sleep studies.',
    createdAt: '2024-04-29'
  },
  {
    id: '105',
    title: 'Idiopathic Hypersomnia',
    category: 'Sleep Disorders',
    description: 'Chronic excessive daytime sleepiness without identifiable cause or cataplexy.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1542736667-069246bdbc6d?w=800&q=80',
    content: 'Idiopathic hypersomnia involves excessive sleep need, prolonged nighttime sleep, and difficulty waking despite adequate rest.',
    createdAt: '2024-04-30'
  },
  {
    id: '106',
    title: 'REM Behavior Disorder (RBD)',
    category: 'Sleep Disorders',
    description: 'A parasomnia where dream enactment occurs due to loss of REM muscle atonia.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1511988617509-a57c8a288659?w=800&q=80',
    content: 'RBD patients physically act out dreams due to absent muscle paralysis during REM sleep, often a precursor to neurodegenerative diseases.',
    createdAt: '2024-05-01'
  },
  {
    id: '107',
    title: 'Circadian Rhythm Sleep Disorders',
    category: 'Sleep Disorders',
    description: 'Conditions where the internal clock is misaligned with the external environment.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1501139083538-0139583c060f?w=800&q=80',
    content: 'These disorders involve disruptions to the body\'s natural sleep-wake timing including delayed sleep phase and advanced sleep phase syndromes.',
    createdAt: '2024-05-02'
  },
  {
    id: '108',
    title: 'Pediatric OSA Overview',
    category: 'Pediatric Sleep',
    description: 'Obstructive sleep apnea in children: unique features, causes, and treatments.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&q=80',
    content: 'Pediatric OSA differs from adult OSA in presentation and often results from enlarged tonsils and adenoids.',
    createdAt: '2024-05-03'
  },
  {
    id: '109',
    title: 'Sleep in Down Syndrome',
    category: 'Pediatric Sleep',
    description: 'Understanding the high prevalence of sleep disorders in Down syndrome.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1555252333-9f8e92e65df9?w=800&q=80',
    content: 'Children with Down syndrome face increased risk of OSA due to anatomical factors requiring specialized screening and treatment.',
    createdAt: '2024-05-04'
  },
  {
    id: '110',
    title: 'Sleep and ADHD',
    category: 'Sleep Disorders',
    description: 'The complex relationship between attention deficit hyperactivity disorder and sleep problems.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80',
    content: 'ADHD and sleep disorders frequently co-occur, with each condition potentially exacerbating the other\'s symptoms.',
    createdAt: '2024-05-05'
  },
  {
    id: '111',
    title: 'Sleep & Psychiatric Conditions',
    category: 'Sleep Disorders',
    description: 'How mental health disorders impact sleep and vice versa.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1527689368864-3a821dbccc34?w=800&q=80',
    content: 'Psychiatric conditions including depression, anxiety, and bipolar disorder have bidirectional relationships with sleep disturbances.',
    createdAt: '2024-05-06'
  },
  {
    id: '112',
    title: 'Cognitive Behavioral Therapy for Insomnia (CBT-I)',
    category: 'Treatments',
    description: 'Evidence-based psychological treatment for chronic insomnia without medication.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80',
    content: 'CBT-I is the first-line treatment for chronic insomnia, addressing thoughts, behaviors, and habits that interfere with sleep.',
    createdAt: '2024-05-07'
  },
  {
    id: '113',
    title: 'Relaxation Techniques for Sleep',
    category: 'Sleep Health',
    description: 'Practical methods to calm the mind and body for better sleep onset.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80',
    content: 'Techniques including progressive muscle relaxation, deep breathing, and guided imagery can reduce pre-sleep arousal.',
    createdAt: '2024-05-08'
  },
  {
    id: '114',
    title: 'Sleep Environment Optimization',
    category: 'Sleep Health',
    description: 'Creating the ideal bedroom conditions for restorative sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1617104678098-de229db51175?w=800&q=80',
    content: 'Optimal sleep environments are cool, dark, quiet, and comfortable, promoting uninterrupted restorative sleep.',
    createdAt: '2024-05-09'
  },
  {
    id: '115',
    title: 'Lifestyle Factors (Caffeine, Alcohol, Exercise)',
    category: 'Lifestyle & Sleep',
    description: 'How daily habits significantly impact sleep quality and duration.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d?w=800&q=80',
    content: 'Caffeine timing, alcohol consumption, and exercise patterns profoundly affect sleep architecture and quality.',
    createdAt: '2024-05-10'
  },
  {
    id: '116',
    title: 'PSG Equipment Overview',
    category: 'Diagnosis',
    description: 'Essential sensors and devices used in comprehensive sleep studies.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1581594549595-35f6edc7b762?w=800&q=80',
    content: 'Polysomnography equipment includes EEG, EOG, EMG, respiratory sensors, oximetry, and video monitoring for complete assessment.',
    createdAt: '2024-05-11'
  },
  {
    id: '117',
    title: 'EEG Basics for Sleep Techs',
    category: 'Diagnosis',
    description: 'Understanding electroencephalography for sleep stage identification.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&q=80',
    content: 'EEG monitors brain electrical activity, revealing distinct patterns for wake, NREM, and REM sleep stages.',
    createdAt: '2024-05-12'
  },
  {
    id: '118',
    title: 'EOG & EMG Fundamentals',
    category: 'Diagnosis',
    description: 'Eye movement and muscle activity monitoring in sleep studies.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=800&q=80',
    content: 'EOG tracks eye movements to identify REM sleep, while EMG detects muscle tone changes and limb movements.',
    createdAt: '2024-05-13'
  },
  {
    id: '119',
    title: 'Respiratory Sensors Overview',
    category: 'Diagnosis',
    description: 'Monitoring airflow, breathing effort, and respiratory patterns during sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80',
    content: 'Respiratory monitoring uses nasal pressure transducers, thermistors, and effort belts to detect apneas and hypopneas.',
    createdAt: '2024-05-14'
  },
  {
    id: '120',
    title: 'Oximetry & CO₂ Monitoring',
    category: 'Diagnosis',
    description: 'Measuring oxygen saturation and carbon dioxide levels during sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=800&q=80',
    content: 'Pulse oximetry and capnography reveal the physiological impact of sleep-disordered breathing on gas exchange.',
    createdAt: '2024-05-15'
  },
  {
    id: '121',
    title: 'Snore, Body Position, and ECG Channels',
    category: 'Diagnosis',
    description: 'Additional monitoring channels providing comprehensive sleep data.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?w=800&q=80',
    content: 'Snore sensors, position detectors, and ECG add valuable context to sleep study interpretations.',
    createdAt: '2024-05-16'
  },
  {
    id: '122',
    title: 'Artifact Recognition & Troubleshooting',
    category: 'Diagnosis',
    description: 'Identifying and resolving technical issues in sleep study recordings.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1579684453423-f84349ef60b0?w=800&q=80',
    content: 'Recognizing artifacts from movement, electrical interference, or equipment malfunction ensures accurate sleep data interpretation.',
    createdAt: '2024-05-17'
  },
  {
    id: '123',
    title: 'AASM Scoring Manual Overview',
    category: 'Diagnosis',
    description: 'Standardized guidelines for sleep study interpretation and scoring.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=800&q=80',
    content: 'The AASM scoring manual provides evidence-based standards for identifying sleep stages and respiratory events.',
    createdAt: '2024-05-18'
  },
  {
    id: '124',
    title: 'Scoring Respiratory Events (Apneas, Hypopneas, RERAs)',
    category: 'Diagnosis',
    description: 'Precise criteria for identifying and classifying breathing disturbances.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1532619675605-1ede6c2ed2b0?w=800&q=80',
    content: 'Respiratory event scoring requires specific duration, airflow reduction, and desaturation criteria per AASM guidelines.',
    createdAt: '2024-05-19'
  },
  {
    id: '125',
    title: 'Scoring Arousals',
    category: 'Diagnosis',
    description: 'Identifying brief awakenings that fragment sleep architecture.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
    content: 'Arousals are sudden shifts in EEG frequency lasting 3-15 seconds that disrupt sleep continuity without full awakening.',
    createdAt: '2024-05-20'
  },
  {
    id: '126',
    title: 'Scoring Limb Movements',
    category: 'Diagnosis',
    description: 'Detecting and quantifying periodic leg movements during sleep studies.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80',
    content: 'Limb movement scoring identifies PLMD by detecting repetitive leg movements meeting specific duration and frequency criteria.',
    createdAt: '2024-05-21'
  },
  {
    id: '127',
    title: 'Light vs Deep Sleep Scoring Challenges',
    category: 'Diagnosis',
    description: 'Common difficulties in differentiating sleep stages and solutions.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&q=80',
    content: 'Ambiguous EEG patterns, especially at stage transitions, require careful analysis and adherence to scoring rules.',
    createdAt: '2024-05-22'
  },
  {
    id: '128',
    title: 'Pediatric Scoring Differences',
    category: 'Pediatric Sleep',
    description: 'Age-specific modifications to sleep study interpretation for children.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&q=80',
    content: 'Pediatric scoring uses different thresholds for respiratory events and accounts for developmental sleep architecture differences.',
    createdAt: '2024-05-23'
  },
  {
    id: '129',
    title: 'HSAT (Home Sleep Apnea Testing) Overview',
    category: 'Diagnosis',
    description: 'Simplified at-home testing for obstructive sleep apnea diagnosis.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80',
    content: 'HSAT provides convenient, cost-effective screening for OSA using limited channels in the patient\'s home environment.',
    createdAt: '2024-05-24'
  },
  {
    id: '130',
    title: 'When to Choose PSG vs HSAT',
    category: 'Diagnosis',
    description: 'Clinical decision-making for appropriate sleep testing modality.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80',
    content: 'PSG is required for complex cases, central apnea, or comorbidities, while HSAT suits straightforward OSA evaluation.',
    createdAt: '2024-05-25'
  },
  {
    id: '131',
    title: 'Auto-PAP Mechanics',
    category: 'Treatment Devices',
    description: 'How automatic positive airway pressure devices adjust to breathing patterns.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584467541268-b040f83be3fd?w=800&q=80',
    content: 'Auto-PAP algorithms detect airflow limitations and adjust pressure breath-by-breath to maintain airway patency.',
    createdAt: '2024-05-26'
  },
  {
    id: '132',
    title: 'Mask Types Overview',
    category: 'Treatment Devices',
    description: 'Comprehensive guide to CPAP mask styles and selection criteria.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1591228127791-8e2eaef098d3?w=800&q=80',
    content: 'Mask options include nasal masks, nasal pillows, and full-face masks, each suited to different patient needs and preferences.',
    createdAt: '2024-05-27'
  },
  {
    id: '133',
    title: 'Mask Fitting & Leak Control',
    category: 'Treatment Devices',
    description: 'Achieving optimal mask seal for effective CPAP therapy.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1585435557343-3b092031a831?w=800&q=80',
    content: 'Proper mask fitting minimizes leaks, improves comfort, and maximizes therapy effectiveness through careful sizing and adjustment.',
    createdAt: '2024-05-28'
  },
  {
    id: '134',
    title: 'PAP Titration Protocols',
    category: 'Treatments',
    description: 'Systematic approaches to determining optimal PAP therapy pressure.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    content: 'Titration studies gradually increase pressure during polysomnography to find the minimum effective level eliminating respiratory events.',
    createdAt: '2024-05-29'
  },
  {
    id: '135',
    title: 'Treating Complex Sleep Apnea',
    category: 'Treatments',
    description: 'Managing treatment-emergent central apneas and mixed patterns.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=800&q=80',
    content: 'Complex sleep apnea requires specialized therapies like ASV when CPAP reveals or worsens central apneas.',
    createdAt: '2024-05-30'
  },
  {
    id: '136',
    title: 'PAP Troubleshooting & Comfort Adjustments',
    category: 'Treatments',
    description: 'Solutions for common CPAP therapy challenges and side effects.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    content: 'Addressing mask discomfort, pressure intolerance, dry mouth, and claustrophobia improves long-term PAP adherence.',
    createdAt: '2024-05-31'
  },
  {
    id: '137',
    title: 'Humidification & Heated Tubing',
    category: 'Treatment Devices',
    description: 'Managing humidity levels to enhance CPAP comfort and compliance.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1582560475093-ba66accbc424?w=800&q=80',
    content: 'Heated humidification and tubing prevent dryness, congestion, and rainout, significantly improving therapy comfort.',
    createdAt: '2024-06-01'
  },
  {
    id: '138',
    title: 'Sleep in Toddlers',
    category: 'Pediatric Sleep',
    description: 'Understanding sleep needs and common challenges in ages 1-3 years.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1555252333-9f8e92e65df9?w=800&q=80',
    content: 'Toddler sleep involves transition from multiple naps to one nap, with typical bedtime resistance and night wakings.',
    createdAt: '2024-06-02'
  },
  {
    id: '139',
    title: 'Pediatric Parasomnias',
    category: 'Pediatric Sleep',
    description: 'Sleep disorders like sleepwalking and night terrors specific to children.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&q=80',
    content: 'Most pediatric parasomnias are benign, occur during deep sleep, and typically resolve with age and improved sleep hygiene.',
    createdAt: '2024-06-03'
  },
  {
    id: '140',
    title: 'Pediatric Insomnia',
    category: 'Pediatric Sleep',
    description: 'Causes and behavioral treatments for childhood insomnia.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&q=80',
    content: 'Pediatric insomnia often stems from behavioral issues and responds well to consistent routines and limit-setting.',
    createdAt: '2024-06-04'
  },
  {
    id: '141',
    title: 'Special Populations (Neuromuscular, Craniofacial, Prematurity)',
    category: 'Pediatric Sleep',
    description: 'Sleep challenges in children with complex medical conditions.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1555252333-9f8e92e65df9?w=800&q=80',
    content: 'Children with neuromuscular disorders, craniofacial abnormalities, or prematurity face increased sleep-disordered breathing risks.',
    createdAt: '2024-06-05'
  },
  {
    id: '142',
    title: 'Pediatric PAP Therapy',
    category: 'Pediatric Sleep',
    description: 'Unique considerations for CPAP use in children and adolescents.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&q=80',
    content: 'Pediatric PAP requires specialized masks, lower pressures, behavioral support, and monitoring for facial growth effects.',
    createdAt: '2024-06-06'
  },
  {
    id: '143',
    title: 'Parental Guidance & Sleep Counseling',
    category: 'Pediatric Sleep',
    description: 'Educating parents on promoting healthy sleep habits in children.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1555252333-9f8e92e65df9?w=800&q=80',
    content: 'Sleep counseling empowers parents with strategies for establishing routines, managing resistance, and creating optimal sleep environments.',
    createdAt: '2024-06-07'
  },
  {
    id: '144',
    title: 'Anxiety & Sleep',
    category: 'Lifestyle & Sleep',
    description: 'The reciprocal relationship between anxiety disorders and sleep disturbances.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=800&q=80',
    content: 'Anxiety causes hyperarousal that interferes with sleep onset, while poor sleep worsens anxiety symptoms.',
    createdAt: '2024-06-08'
  },
  {
    id: '145',
    title: 'Depression & Sleep',
    category: 'Lifestyle & Sleep',
    description: 'Understanding the complex interplay between depression and sleep problems.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1527689368864-3a821dbccc34?w=800&q=80',
    content: 'Depression commonly presents with insomnia or hypersomnia, and sleep improvement often aids in depression treatment.',
    createdAt: '2024-06-09'
  },
  {
    id: '146',
    title: 'Substance Use & Sleep',
    category: 'Lifestyle & Sleep',
    description: 'How alcohol, drugs, and medications affect sleep architecture and quality.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1551782450-17144efb9c50?w=800&q=80',
    content: 'Substance use alters sleep stages, particularly REM sleep, and withdrawal often causes severe sleep disturbances.',
    createdAt: '2024-06-10'
  },
  {
    id: '147',
    title: 'Meditation & Sleep',
    category: 'Sleep Health',
    description: 'Mindfulness practices to improve sleep quality and reduce insomnia.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1545389336-cf090694435e?w=800&q=80',
    content: 'Regular meditation reduces sleep-interfering rumination and hyperarousal, improving both sleep onset and quality.',
    createdAt: '2024-06-11'
  },
  {
    id: '148',
    title: 'Exercise Timing & Sleep',
    category: 'Lifestyle & Sleep',
    description: 'Optimizing workout schedules for better nighttime rest.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800&q=80',
    content: 'Exercise improves sleep quality, but timing matters - vigorous evening workouts may delay sleep onset in some individuals.',
    createdAt: '2024-06-12'
  },
  {
    id: '149',
    title: 'Neuroscience of Sleep Deprivation',
    category: 'Neuroscience Fundamentals',
    description: 'Brain changes and cognitive consequences of insufficient sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1617791160588-241658c0f566?w=800&q=80',
    content: 'Sleep deprivation impairs prefrontal cortex function, amygdala regulation, and hippocampal memory processing.',
    createdAt: '2024-06-13'
  },
  {
    id: '150',
    title: 'Future of Sleep Medicine & Technology',
    category: 'Sleep Technologies',
    description: 'Emerging innovations transforming sleep diagnosis and treatment.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=800&q=80',
    content: 'Advances in AI, wearables, telemedicine, and targeted neuromodulation promise personalized, accessible sleep healthcare.',
    createdAt: '2024-06-14'
  },
  // NEW HIGH-ENGAGEMENT TOPICS (Tier 1)
  {
    id: '151',
    title: 'Why Can\'t I Sleep?',
    category: 'Symptoms',
    description: 'Understanding the most common reasons people struggle to fall or stay asleep, and what you can do about it.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=800&q=80',
    content: 'Difficulty sleeping is one of the most common health complaints worldwide, affecting up to 35% of adults at some point.',
    createdAt: '2024-06-15'
  },
  {
    id: '152',
    title: 'Waking Up at 3 AM',
    category: 'Symptoms',
    description: 'Why you keep waking up in the middle of the night and evidence-based strategies to sleep through.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584467735815-f778f274e296?w=800&q=80',
    content: 'Middle-of-the-night awakenings are extremely common and often have identifiable, treatable causes.',
    createdAt: '2024-06-16'
  },
  {
    id: '153',
    title: 'Excessive Daytime Sleepiness',
    category: 'Symptoms',
    description: 'Understanding why you feel tired all day despite sleeping, and when to seek medical evaluation.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=800&q=80',
    content: 'Excessive daytime sleepiness (EDS) affects quality of life and may indicate an underlying sleep disorder.',
    createdAt: '2024-06-17'
  },
  // CLINICAL CONTROVERSIES - BATCH 1
  {
    id: '154',
    title: 'AASM 1A vs 1B Scoring Criteria',
    category: 'Clinical Controversies',
    description: 'The ongoing debate over hypopnea scoring rules and their clinical implications.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80',
    content: 'A clinical debate examining the differences between AASM 1A and 1B hypopnea definitions and their impact on diagnosis.',
    createdAt: '2024-06-18'
  },
  {
    id: '155',
    title: 'PSG vs HSAT: Diagnostic Debate',
    category: 'Clinical Controversies',
    description: 'Comparing in-lab polysomnography with home sleep apnea testing for OSA diagnosis.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&q=80',
    content: 'A clinical debate on when to use laboratory polysomnography versus home sleep apnea testing.',
    createdAt: '2024-06-19'
  },
  {
    id: '156',
    title: 'AI vs Human Scoring',
    category: 'Clinical Controversies',
    description: 'The emerging debate on artificial intelligence in sleep study interpretation.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80',
    content: 'A clinical debate exploring whether AI can match or exceed human accuracy in sleep study scoring.',
    createdAt: '2024-06-20'
  },
  {
    id: '157',
    title: 'UARS: The Diagnostic Debate',
    category: 'Clinical Controversies',
    description: 'Is Upper Airway Resistance Syndrome a distinct condition or part of the OSA spectrum?',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584467735815-f778f274e296?w=800&q=80',
    content: 'A clinical debate on whether UARS deserves separate diagnostic recognition or represents mild sleep-disordered breathing.',
    createdAt: '2024-06-21'
  },
  {
    id: '158',
    title: 'CPAP Compliance Standards',
    category: 'Clinical Controversies',
    description: 'Questioning whether current adherence metrics truly reflect therapeutic benefit.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800&q=80',
    content: 'A clinical debate on CPAP compliance definitions and whether the 4-hour threshold is clinically meaningful.',
    createdAt: '2024-06-22'
  },
  // TIER 2 CORE TOPICS
  {
    id: '159',
    title: 'Bruxism (Teeth Grinding)',
    category: 'Sleep Disorders',
    description: 'Understanding sleep-related teeth grinding, its connection to sleep disorders, and treatment options.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=800&q=80',
    content: 'Sleep bruxism affects up to 13% of adults and can cause dental damage, jaw pain, and sleep disruption.',
    createdAt: '2024-06-23'
  },
  {
    id: '160',
    title: 'Nocturia (Nighttime Urination)',
    category: 'Symptoms',
    description: 'Why you wake up to urinate at night and how it relates to sleep quality and underlying conditions.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584820927498-cfe5211fd8bf?w=800&q=80',
    content: 'Nocturia affects over 50% of adults over 50 and significantly impacts sleep quality and daytime function.',
    createdAt: '2024-06-24'
  },
  {
    id: '161',
    title: 'Shift Work Sleep Disorder',
    category: 'Sleep Disorders',
    description: 'Managing sleep and health when your work schedule conflicts with your natural circadian rhythm.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80',
    content: 'Shift work affects 20% of workers worldwide and increases risk of sleep disorders, accidents, and chronic disease.',
    createdAt: '2024-06-25'
  },
  {
    id: '162',
    title: 'Jet Lag',
    category: 'Sleep Disorders',
    description: 'Understanding circadian disruption from travel and evidence-based strategies for faster recovery.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&q=80',
    content: 'Jet lag occurs when rapid travel across time zones desynchronizes your internal clock from local time.',
    createdAt: '2024-06-26'
  },
  {
    id: '163',
    title: 'Sleep Trackers (Oura, Whoop, Apple Watch)',
    category: 'Sleep Technologies',
    description: 'What consumer sleep trackers can and cannot tell you about your sleep quality.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1434494878577-86c23bcb06b9?w=800&q=80',
    content: 'Consumer sleep trackers have become popular tools for self-monitoring, but understanding their limitations is essential.',
    createdAt: '2024-06-27'
  },
  {
    id: '164',
    title: 'Weighted Blankets',
    category: 'Treatments',
    description: 'The science behind weighted blankets and who may benefit from deep pressure stimulation.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1540518614846-7eded433c457?w=800&q=80',
    content: 'Weighted blankets provide deep pressure stimulation that may help reduce anxiety and improve sleep in some individuals.',
    createdAt: '2024-06-28'
  },
  {
    id: '165',
    title: 'Alcohol and Sleep',
    category: 'Lifestyle & Sleep',
    description: 'How alcohol affects sleep architecture, quality, and long-term sleep health.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=800&q=80',
    content: 'While alcohol may help you fall asleep faster, it significantly disrupts sleep quality and architecture.',
    createdAt: '2024-06-29'
  },
  {
    id: '166',
    title: 'Caffeine and Sleep (Deep Dive)',
    category: 'Lifestyle & Sleep',
    description: 'The science of caffeine metabolism, individual variation, and optimizing caffeine timing for sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&q=80',
    content: 'Caffeine is the world\'s most consumed psychoactive substance and its effects on sleep vary significantly by individual.',
    createdAt: '2024-06-30'
  },
  // CLINICAL CONTROVERSIES - BATCH 2
  {
    id: '167',
    title: 'GLP-1 Drugs for Sleep Apnea',
    category: 'Clinical Controversies',
    description: 'Emerging evidence on weight loss medications and their potential role in treating sleep apnea.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80',
    content: 'A clinical debate on whether GLP-1 medications represent a new treatment paradigm for obstructive sleep apnea.',
    createdAt: '2024-07-01'
  },
  {
    id: '168',
    title: 'MAD vs CPAP',
    category: 'Clinical Controversies',
    description: 'Comparing mandibular advancement devices and CPAP for sleep apnea treatment.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1609840114035-3c981b782dfe?w=800&q=80',
    content: 'A clinical debate on when oral appliances should be considered as first-line therapy for OSA.',
    createdAt: '2024-07-02'
  },
  {
    id: '169',
    title: 'COMISA Treatment Sequencing',
    category: 'Clinical Controversies',
    description: 'The challenge of treating patients with both insomnia and sleep apnea.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    content: 'A clinical debate on whether to treat insomnia or sleep apnea first when both conditions coexist.',
    createdAt: '2024-07-03'
  },
  {
    id: '170',
    title: 'Melatonin Use in Children',
    category: 'Clinical Controversies',
    description: 'Examining the safety and appropriateness of melatonin supplementation in pediatric populations.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&q=80',
    content: 'A clinical debate on pediatric melatonin use given limited long-term safety data and widespread availability.',
    createdAt: '2024-07-04'
  },
  {
    id: '171',
    title: 'Drowsy Driving',
    category: 'Clinical Controversies',
    description: 'The public health crisis of sleep-deprived driving and policy debates around prevention.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800&q=80',
    content: 'A clinical and policy debate on drowsy driving risks, regulations, and professional responsibilities.',
    createdAt: '2024-07-05'
  },
  {
    id: '172',
    title: 'School Start Times',
    category: 'Clinical Controversies',
    description: 'The debate over delaying school start times to align with adolescent sleep biology.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=800&q=80',
    content: 'A clinical and policy debate on whether later school start times should be mandated for adolescent health.',
    createdAt: '2024-07-06'
  },
  {
    id: '173',
    title: 'Standard Time vs Daylight Saving Time',
    category: 'Clinical Controversies',
    description: 'The health impacts of clock changes and the debate over permanent time standards.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1501139083538-0139583c060f?w=800&q=80',
    content: 'A clinical and policy debate on whether DST should be eliminated in favor of permanent standard time.',
    createdAt: '2024-07-07'
  },
  {
    id: '174',
    title: 'Sleep Divorce',
    category: 'Clinical Controversies',
    description: 'The growing trend of couples sleeping separately and its implications for relationships and health.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=800&q=80',
    content: 'A clinical and social debate on whether separate sleeping arrangements benefit or harm relationships.',
    createdAt: '2024-07-08'
  },
  {
    id: '175',
    title: 'Co-Sleeping with Infants',
    category: 'Clinical Controversies',
    description: 'Balancing SIDS prevention guidelines with attachment parenting and cultural practices.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1555252333-9f8e92e65df9?w=800&q=80',
    content: 'A clinical debate examining the risks and benefits of infant bed-sharing versus room-sharing.',
    createdAt: '2024-07-09'
  },
  {
    id: '176',
    title: 'Long-Term Use of Sleep Aids',
    category: 'Clinical Controversies',
    description: 'The debate over chronic use of prescription and OTC sleep medications.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80',
    content: 'A clinical debate on the risks, benefits, and appropriate duration of pharmacological sleep treatment.',
    createdAt: '2024-07-10'
  },
  // ═══════════════════════════════════════════════════════════════════════════
  // PHASE 6: EQUIPMENT, LIFESTYLE & TRENDING TOPICS
  // ═══════════════════════════════════════════════════════════════════════════
  // EQUIPMENT & TECHNOLOGY
  {
    id: '177',
    title: 'CPAP Masks Guide',
    category: 'Treatment Devices',
    description: 'Complete guide to CPAP mask types, fitting, and troubleshooting common issues.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=800&q=80',
    content: 'Choosing the right CPAP mask is crucial for therapy success. Learn about nasal, full face, and nasal pillow options.',
    createdAt: '2024-07-15'
  },
  {
    id: '178',
    title: 'BiPAP vs CPAP vs APAP',
    category: 'Treatment Devices',
    description: 'Understanding the differences between positive airway pressure device types.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1516549655169-df83a0774514?w=800&q=80',
    content: 'Comparing CPAP, BiPAP, and Auto-PAP devices to help determine which therapy is right for different conditions.',
    createdAt: '2024-07-15'
  },
  {
    id: '179',
    title: 'Eight Sleep Pod & Smart Cooling Mattresses',
    category: 'Sleep Technologies',
    description: 'Smart mattress technology that regulates temperature for optimal sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=800&q=80',
    content: 'Temperature-regulating mattress technology claims to improve sleep quality through personalized cooling and heating.',
    createdAt: '2024-07-15'
  },
  {
    id: '180',
    title: 'Best Mattresses for Sleep Position',
    category: 'Sleep Health',
    description: 'Choosing the right mattress firmness for side sleepers vs back sleepers.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80',
    content: 'Sleep position significantly impacts mattress needs. Side sleepers need softer surfaces, back sleepers need medium-firm support.',
    createdAt: '2024-07-15'
  },
  {
    id: '181',
    title: 'Sunrise Alarm Clocks',
    category: 'Sleep Technologies',
    description: 'Light-based wake-up devices that simulate natural dawn for gentler awakening.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1533749871411-5e21e14bcc7d?w=800&q=80',
    content: 'Sunrise alarm clocks gradually increase light intensity to wake you naturally, potentially improving morning alertness.',
    createdAt: '2024-07-15'
  },
  {
    id: '182',
    title: 'Ergonomic Pillows for Neck Pain',
    category: 'Sleep Health',
    description: 'Specialized pillows designed to maintain proper cervical alignment during sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584100936595-c0654b55a2e2?w=800&q=80',
    content: 'Proper pillow selection can reduce neck pain and improve sleep quality by maintaining neutral spine alignment.',
    createdAt: '2024-07-15'
  },
  {
    id: '183',
    title: 'White Noise vs Pink Noise vs Brown Noise',
    category: 'Sleep Technologies',
    description: 'Understanding different sound frequencies and their effects on sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
    content: 'Different noise colors have distinct frequency profiles that may affect sleep differently for various individuals.',
    createdAt: '2024-07-15'
  },
  {
    id: '184',
    title: 'Blackout Curtains & Sleep Masks',
    category: 'Sleep Health',
    description: 'Light-blocking solutions for optimizing the sleep environment.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=800&q=80',
    content: 'Light exposure during sleep disrupts circadian rhythms and melatonin production. Blackout solutions can significantly improve sleep.',
    createdAt: '2024-07-15'
  },
  {
    id: '185',
    title: 'Smart Beds & Adjustable Frames',
    category: 'Sleep Technologies',
    description: 'Adjustable bed technology for snoring reduction and comfort optimization.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1505693314120-0d443867891c?w=800&q=80',
    content: 'Adjustable beds can elevate the head to reduce snoring and GERD symptoms, with smart features tracking sleep quality.',
    createdAt: '2024-07-15'
  },
  // LIFESTYLE & BEHAVIORAL
  {
    id: '186',
    title: 'Mouth Taping for Nasal Breathing',
    category: 'Clinical Controversies',
    description: 'The debate over taping the mouth shut during sleep to promote nasal breathing.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800&q=80',
    content: 'A clinical debate on the safety and efficacy of mouth taping as a sleep optimization technique.',
    createdAt: '2024-07-16'
  },
  {
    id: '187',
    title: 'Digital Detox Before Bed',
    category: 'Lifestyle & Sleep',
    description: 'The importance of disconnecting from screens before sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1512428559087-560fa5ceab42?w=800&q=80',
    content: 'Screen time before bed affects sleep through blue light exposure and mental stimulation. Learn optimal wind-down strategies.',
    createdAt: '2024-07-16'
  },
  {
    id: '188',
    title: 'Morning Sunlight & Circadian Alignment',
    category: 'Lifestyle & Sleep',
    description: 'How early light exposure sets your internal clock for better sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?w=800&q=80',
    content: 'Morning sunlight is the most powerful circadian rhythm regulator, affecting sleep timing, energy, and mood.',
    createdAt: '2024-07-16'
  },
  {
    id: '189',
    title: 'Ideal Bedroom Temperature',
    category: 'Sleep Health',
    description: 'Why 65°F (18°C) is considered optimal for sleep and how to achieve it.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1631049552057-403cdb8f0658?w=800&q=80',
    content: 'Body temperature naturally drops during sleep. A cool bedroom environment supports this process for better rest.',
    createdAt: '2024-07-16'
  },
  {
    id: '190',
    title: 'Evening Exercise & Sleep Quality',
    category: 'Lifestyle & Sleep',
    description: 'How timing and intensity of exercise affects sleep onset and quality.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80',
    content: 'Exercise improves sleep, but timing matters. Learn the optimal window for physical activity relative to bedtime.',
    createdAt: '2024-07-16'
  },
  {
    id: '191',
    title: 'Bedtime Meditation & Breathing Techniques',
    category: 'Lifestyle & Sleep',
    description: 'Relaxation methods including the 4-7-8 breathing technique for sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80',
    content: 'Mind-body techniques can reduce pre-sleep arousal and improve sleep onset through parasympathetic activation.',
    createdAt: '2024-07-16'
  },
  {
    id: '192',
    title: 'Power Napping Science',
    category: 'Sleep Science',
    description: 'Optimal nap duration: 20-minute refresher vs 90-minute full cycle.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=800&q=80',
    content: 'Strategic napping can boost alertness and performance when done correctly, but poor timing can disrupt nighttime sleep.',
    createdAt: '2024-07-16'
  },
  {
    id: '193',
    title: 'Blue Light Blocking Glasses',
    category: 'Sleep Technologies',
    description: 'Do blue light glasses actually improve sleep? Examining the evidence.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?w=800&q=80',
    content: 'Blue light from screens suppresses melatonin. Blue-blocking glasses claim to mitigate this effect, but evidence is mixed.',
    createdAt: '2024-07-16'
  },
  {
    id: '194',
    title: 'Earplugs for Sleeping',
    category: 'Sleep Health',
    description: 'Solutions for sleeping with a snoring partner or in noisy environments.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1590935217281-8f102120d683?w=800&q=80',
    content: 'Noise during sleep causes arousals even when not remembered. Earplugs can protect sleep quality in noisy environments.',
    createdAt: '2024-07-16'
  },
  // TRENDING & SPECIAL TOPICS
  {
    id: '195',
    title: 'Bed Rotting',
    category: 'Clinical Controversies',
    description: 'The TikTok trend of spending all day in bed: self-care or harmful habit?',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1515894203077-9cd36032142f?w=800&q=80',
    content: 'A clinical perspective on the viral "bed rotting" trend and its implications for sleep health and mental wellness.',
    createdAt: '2024-07-17'
  },
  {
    id: '196',
    title: 'Polyphasic Sleep Schedules',
    category: 'Clinical Controversies',
    description: 'Examining Uberman, Everyman, and other alternative sleep patterns.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1495364141860-b0d03eccd065?w=800&q=80',
    content: 'A clinical debate on whether polyphasic sleep schedules are sustainable or harmful to health and cognition.',
    createdAt: '2024-07-17'
  },
  {
    id: '197',
    title: 'Sleep Tourism',
    category: 'Cultural & Historical',
    description: 'Hotels and destinations curated specifically for rest and sleep optimization.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80',
    content: 'The emerging travel trend focused on sleep-optimized accommodations, from sleep retreats to luxury sleep suites.',
    createdAt: '2024-07-17'
  },
  // ═══════════════════════════════════════════════════════════════════════════
  // PHASE 7: SYMPTOMS, DISORDERS & SUPPLEMENTS
  // ═══════════════════════════════════════════════════════════════════════════
  // SYMPTOMS & EXPERIENCES
  {
    id: '198',
    title: 'Sleep Inertia (Sleep Drunkenness)',
    category: 'Symptoms',
    description: 'Brain fog and grogginess after waking — why you feel worse before you feel better.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=800&q=80',
    content: 'Sleep inertia is the transitional state between sleep and wakefulness marked by impaired performance and grogginess.',
    createdAt: '2024-07-20'
  },
  {
    id: '199',
    title: 'Chronic Fatigue vs Normal Tiredness',
    category: 'Symptoms',
    description: 'Understanding the difference between everyday tiredness and pathological fatigue.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1516534775068-ba3e7458af70?w=800&q=80',
    content: 'Not all fatigue is the same. Learn when tiredness is normal and when it signals something more serious.',
    createdAt: '2024-07-20'
  },
  {
    id: '200',
    title: 'Feeling Tired After 8 Hours of Sleep',
    category: 'Symptoms',
    description: 'Why adequate sleep duration doesn\'t always equal feeling rested.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1515894203077-9cd36032142f?w=800&q=80',
    content: 'Sleep quantity and quality are different. Discover why you might still feel exhausted after a full night.',
    createdAt: '2024-07-20'
  },
  {
    id: '201',
    title: 'Morning Headaches & Dry Mouth',
    category: 'Symptoms',
    description: 'Common morning symptoms that may indicate sleep-disordered breathing.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1616012480717-fd9867059ca0?w=800&q=80',
    content: 'Waking with headaches or dry mouth can be warning signs of sleep apnea and other conditions.',
    createdAt: '2024-07-20'
  },
  {
    id: '202',
    title: 'Night Sweats',
    category: 'Symptoms',
    description: 'Causes of excessive sweating during sleep — from hormones to sleep disorders.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80',
    content: 'Night sweats can be caused by menopause, infections, medications, sleep apnea, and other conditions.',
    createdAt: '2024-07-20'
  },
  {
    id: '203',
    title: 'Hypnagogic Jerks (Sleep Starts)',
    category: 'Symptoms',
    description: 'The sudden falling sensation as you drift off to sleep — why it happens.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1515894203077-9cd36032142f?w=800&q=80',
    content: 'Hypnagogic jerks are involuntary muscle contractions that occur as you transition from wakefulness to sleep.',
    createdAt: '2024-07-20'
  },
  {
    id: '204',
    title: 'Fever Dreams & Vivid Nightmares',
    category: 'Symptoms',
    description: 'Why illness and stress produce intense, disturbing dreams.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1534447677768-be436bb09401?w=800&q=80',
    content: 'Fever and stress alter REM sleep patterns, leading to more vivid and often disturbing dream experiences.',
    createdAt: '2024-07-20'
  },
  {
    id: '205',
    title: 'Sudden Gasping for Air While Sleeping',
    category: 'Symptoms',
    description: 'Waking up choking or gasping — a key warning sign of sleep apnea.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584467541268-b040f83be3fd?w=800&q=80',
    content: 'Gasping awake from sleep is often caused by obstructive sleep apnea and requires medical evaluation.',
    createdAt: '2024-07-20'
  },
  {
    id: '206',
    title: 'Dark Circles Under Eyes',
    category: 'Symptoms',
    description: 'The connection between sleep deprivation and under-eye appearance.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=800&q=80',
    content: 'Sleep loss causes blood vessel dilation and fluid accumulation that contribute to dark circles.',
    createdAt: '2024-07-20'
  },
  // SLEEP DISORDERS
  {
    id: '207',
    title: 'Delayed Sleep Phase Syndrome',
    category: 'Sleep Disorders',
    description: 'The night owl disorder — when your body clock runs hours behind society.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&q=80',
    content: 'DSPS is a circadian rhythm disorder where sleep timing is delayed 2+ hours beyond conventional times.',
    createdAt: '2024-07-20'
  },
  {
    id: '208',
    title: 'Advanced Sleep Phase Syndrome',
    category: 'Sleep Disorders',
    description: 'The early bird disorder — falling asleep and waking hours before others.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?w=800&q=80',
    content: 'ASPS causes very early sleep onset and wake times, often creating social and occupational challenges.',
    createdAt: '2024-07-20'
  },
  {
    id: '209',
    title: 'Sleep-Related Eating Disorder',
    category: 'Parasomnias',
    description: 'Unconscious eating during sleep — causes, risks, and treatment.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=800&q=80',
    content: 'Sleep-related eating disorder involves recurrent episodes of eating during partial arousals from sleep.',
    createdAt: '2024-07-20'
  },
  {
    id: '210',
    title: 'Exploding Head Syndrome',
    category: 'Parasomnias',
    description: 'Hearing loud noises or explosions when falling asleep or waking — a benign but startling parasomnia.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
    content: 'Despite its alarming name, exploding head syndrome is harmless and involves perceived loud sounds during sleep transitions.',
    createdAt: '2024-07-20'
  },
  {
    id: '211',
    title: 'Racing Thoughts at Night',
    category: 'Symptoms',
    description: 'Cognitive hyperarousal — when your mind won\'t quiet down at bedtime.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1507413245164-6160d8298b31?w=800&q=80',
    content: 'Racing thoughts at bedtime are a hallmark of insomnia and anxiety, driven by cognitive hyperarousal.',
    createdAt: '2024-07-20'
  },
  // SLEEP AIDS & SUPPLEMENTS
  {
    id: '212',
    title: 'Melatonin Dosage Guide',
    category: 'Treatments',
    description: 'Optimal melatonin doses, timing, and potential side effects for adults.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80',
    content: 'Learn about evidence-based melatonin dosing, common mistakes, and when it does (and doesn\'t) help.',
    createdAt: '2024-07-21'
  },
  {
    id: '213',
    title: 'Magnesium for Sleep',
    category: 'Treatments',
    description: 'Comparing magnesium forms — Bisglycinate vs Threonate vs others for sleep.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1550572017-edd951aa8f72?w=800&q=80',
    content: 'Different magnesium forms have different absorption and effects. Learn which may help sleep.',
    createdAt: '2024-07-21'
  },
  {
    id: '214',
    title: 'Ashwagandha for Sleep',
    category: 'Treatments',
    description: 'The adaptogenic herb\'s role in reducing stress and improving sleep quality.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1515694346937-94d85e41e6f0?w=800&q=80',
    content: 'Ashwagandha is an adaptogen that may reduce cortisol and improve sleep in stressed individuals.',
    createdAt: '2024-07-21'
  },
  {
    id: '215',
    title: 'Valerian Root & Chamomile',
    category: 'Treatments',
    description: 'Traditional herbal sleep remedies — what the evidence says.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1563822249366-3efb23b8e0c9?w=800&q=80',
    content: 'Valerian and chamomile have been used for centuries as sleep aids. Examining the research.',
    createdAt: '2024-07-21'
  },
  {
    id: '216',
    title: 'CBD and THC for Sleep',
    category: 'Clinical Controversies',
    description: 'The debate over cannabis compounds for sleep — promise vs. concerns.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1586015555751-63c29a21a0d5?w=800&q=80',
    content: 'A clinical debate on the use of CBD and THC for sleep disorders — examining evidence and risks.',
    createdAt: '2024-07-21'
  },
  {
    id: '217',
    title: 'OTC Sleep Aids',
    category: 'Treatments',
    description: 'Diphenhydramine, Doxylamine, and other over-the-counter options — pros and cons.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=800&q=80',
    content: 'Understanding antihistamine-based OTC sleep aids, their limitations, and when to avoid them.',
    createdAt: '2024-07-21'
  },
  {
    id: '218',
    title: 'Prescription Sleep Medications',
    category: 'Treatments',
    description: 'Z-drugs, DORAs, and other prescription options — mechanisms and considerations.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80',
    content: 'Comparing prescription sleep medications: benzodiazepines, Z-drugs, orexin antagonists, and more.',
    createdAt: '2024-07-21'
  },
  {
    id: '219',
    title: 'Stopping Sleep Medications Safely',
    category: 'Treatments',
    description: 'How to taper off sleeping pills and manage rebound insomnia.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80',
    content: 'Discontinuing sleep medications requires careful planning to avoid withdrawal and rebound insomnia.',
    createdAt: '2024-07-21'
  },
  {
    id: '220',
    title: 'Sleepy Girl Mocktail',
    category: 'Lifestyle & Sleep',
    description: 'The viral TikTok sleep drink — does tart cherry juice and magnesium actually help?',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=800&q=80',
    content: 'Examining the science behind the viral "Sleepy Girl Mocktail" trend and its ingredients.',
    createdAt: '2024-07-21'
  },
  // === NEW DIAGNOSTIC & SCORING CONTROVERSIES (221-224) ===
  {
    id: '221',
    title: 'The 3% vs. 4% Rule',
    category: 'Clinical Controversies',
    description: 'The oxygen desaturation debate — how scoring criteria impact diagnosis and insurance coverage.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80',
    content: 'A clinical debate on hypopnea scoring criteria: the 3% vs. 4% oxygen desaturation rule and its implications.',
    createdAt: '2024-07-22'
  },
  {
    id: '222',
    title: 'At-Home vs. In-Lab Sleep Testing',
    category: 'Clinical Controversies',
    description: 'HST vs. PSG — when is home testing enough, and when do you need the gold standard?',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=800&q=80',
    content: 'The ongoing debate: Home Sleep Testing reliability for complex patients versus the gold standard lab study.',
    createdAt: '2024-07-22'
  },
  {
    id: '223',
    title: 'AI vs. Manual Sleep Scoring',
    category: 'Clinical Controversies',
    description: 'Can AI replace the trained eye? The debate over automated sleep study scoring.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80',
    content: 'Examining whether AI can truly replace experienced technologists for staging N1 or identifying rare findings.',
    createdAt: '2024-07-22'
  },
  {
    id: '224',
    title: 'Watch-Based Sleep Diagnosis',
    category: 'Clinical Controversies',
    description: 'Consumer wearables diagnosing sleep apnea — helpful tool or dangerous trend?',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1434494878577-86c23bcb06b9?w=800&q=80',
    content: 'The controversy over consumers using Apple Watch or Galaxy Watch data to self-diagnose sleep apnea.',
    createdAt: '2024-07-22'
  },
  // === TREATMENT & POLICY DEBATES (225-228) ===
  {
    id: '225',
    title: 'Standard Time vs. Daylight Saving',
    category: 'Clinical Controversies',
    description: 'Sleep experts vs. public preference — the permanent time change debate.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1495364141860-b0d03eccd065?w=800&q=80',
    content: 'AASM and AMA advocate for permanent Standard Time, while legislators and public often prefer Daylight Saving.',
    createdAt: '2024-07-22'
  },
  {
    id: '226',
    title: 'Prescriptions-as-a-Service',
    category: 'Clinical Controversies',
    description: 'Telehealth sleep startups — convenience or clinical shortcut?',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    content: 'Examining companies offering "prescriptions as a product" and the debate over bypassing traditional pathways.',
    createdAt: '2024-07-22'
  },
  {
    id: '227',
    title: 'Restaurant-Menu Medicine',
    category: 'Clinical Controversies',
    description: 'Patients shopping for favorable scoring — when healthcare becomes consumer-driven.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800&q=80',
    content: 'The phenomenon of patients researching scoring metrics and seeking providers who score more aggressively.',
    createdAt: '2024-07-22'
  },
  {
    id: '228',
    title: 'Mouth Taping for Sleep',
    category: 'Clinical Controversies',
    description: 'The viral TikTok trend — harmless hack or dangerous for undiagnosed OSA?',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800&q=80',
    content: 'The medical community warns against mouth taping, especially for those with undiagnosed sleep apnea.',
    createdAt: '2024-07-22'
  },
  // === EMERGING MEDICAL CONFLICTS (229-231) ===
  {
    id: '229',
    title: 'Insomnia vs. Depression',
    category: 'Clinical Controversies',
    description: 'The chicken or the egg — which should be treated first when they co-occur?',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=800&q=80',
    content: 'A clinical debate on treatment prioritization when insomnia and depression present together.',
    createdAt: '2024-07-22'
  },
  {
    id: '230',
    title: 'COMISA',
    category: 'Clinical Controversies',
    description: 'Co-Morbid Insomnia and Sleep Apnea — the challenge of treating both conditions.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584467735815-f778f274e296?w=800&q=80',
    content: 'Managing patients with both insomnia and sleep apnea, where CPAP can initially worsen insomnia symptoms.',
    createdAt: '2024-07-22'
  },
  {
    id: '231',
    title: 'Sleep Optimization vs. Orthosomnia',
    category: 'Clinical Controversies',
    description: 'When the pursuit of perfect sleep causes worse sleep — the tracker paradox.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1434494878577-86c23bcb06b9?w=800&q=80',
    content: 'The concern that high-tech sleep tracking causes anxiety and worse sleep — the "unhealthy pursuit of perfect sleep."',
    createdAt: '2024-07-22'
  },
  // ============================================================
  // CPAP EQUIPMENT & SUPPLIES (232-239)
  // ============================================================
  {
    id: '232',
    title: 'CPAP Maintenance & Cleaning',
    category: 'CPAP Equipment',
    description: 'Complete guide to cleaning and maintaining your CPAP equipment for optimal therapy and hygiene.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1584820927498-cfe5211fd8bf?w=800&q=80',
    content: 'Proper CPAP maintenance is essential for effective therapy and long-term health. A clean CPAP system prevents bacterial growth, skin irritation, and equipment degradation.',
    createdAt: '2024-12-01',
    isPremium: false
  },
  {
    id: '233',
    title: 'How Often to Replace CPAP Supplies',
    category: 'CPAP Equipment',
    description: 'Understanding replacement schedules for masks, tubing, filters, and other CPAP components.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=800&q=80',
    content: 'CPAP supplies have defined lifespans based on wear, hygiene, and therapeutic effectiveness. Using worn components compromises therapy quality.',
    createdAt: '2024-12-01',
    isPremium: false
  },
  {
    id: '234',
    title: 'Mask Cleaning Best Practices',
    category: 'CPAP Equipment',
    description: 'Daily and weekly mask cleaning routines to maintain seal quality and prevent skin issues.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1585435557343-3b092031a831?w=800&q=80',
    content: 'Your CPAP mask is the most critical component for therapy success and the one that requires the most frequent cleaning.',
    createdAt: '2024-12-01',
    isPremium: false
  },
  {
    id: '235',
    title: 'Tubing & Filter Replacement',
    category: 'CPAP Equipment',
    description: 'When and how to replace CPAP tubing and filters for optimal therapy delivery.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80',
    content: 'CPAP tubing and filters are critical but often overlooked components of your therapy system.',
    createdAt: '2024-12-01',
    isPremium: false
  },
  {
    id: '236',
    title: 'CPAP Hygiene Best Practices',
    category: 'CPAP Equipment',
    description: 'Comprehensive hygiene guide covering equipment, environment, and personal care for CPAP users.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1631549916768-4119b4220292?w=800&q=80',
    content: 'Comprehensive CPAP hygiene goes beyond individual component cleaning to your entire sleep environment.',
    createdAt: '2024-12-01',
    isPremium: false
  },
  {
    id: '237',
    title: 'ResMed CPAP Equipment Guide',
    category: 'Manufacturer Guides',
    description: 'Comprehensive guide to ResMed CPAP devices, masks, and maintenance recommendations.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&q=80',
    content: 'ResMed is one of the leading manufacturers of CPAP devices, known for the AirSense series of machines and AirFit series of masks.',
    createdAt: '2024-12-01',
    isPremium: false
  },
  {
    id: '238',
    title: 'Philips CPAP Equipment Guide',
    category: 'Manufacturer Guides',
    description: 'Guide to Philips Respironics CPAP equipment, features, and care instructions.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=800&q=80',
    content: 'Philips Respironics has been a major manufacturer of CPAP equipment for decades, known for the DreamStation series.',
    createdAt: '2024-12-01',
    isPremium: false
  },
  {
    id: '239',
    title: 'Fisher & Paykel CPAP Equipment Guide',
    category: 'Manufacturer Guides',
    description: 'Understanding Fisher & Paykel CPAP devices, ThermoSmart technology, and masks.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    content: 'Fisher & Paykel Healthcare is known for innovative respiratory care products including the SleepStyle CPAP system.',
    createdAt: '2024-12-01',
    isPremium: false
  },
  // ============================================================
  // TREATMENT ADAPTATION & ANXIETY MANAGEMENT (240-244)
  // ============================================================
  {
    id: '240',
    title: 'CPAP Adaptation Guide (First 30 Days)',
    category: 'Treatment Adaptation',
    description: 'Week-by-week guide to successfully adapting to CPAP therapy in your first month.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80',
    content: 'The first 30 days are crucial for establishing habits that lead to long-term success with CPAP therapy.',
    createdAt: '2024-12-01',
    isPremium: false
  },
  {
    id: '241',
    title: 'How to Reduce Anxiety with CPAP',
    category: 'Treatment Adaptation',
    description: 'Strategies to overcome CPAP-related anxiety and build comfort with therapy.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80',
    content: 'Anxiety about CPAP therapy is extremely common. Understanding proven strategies can help overcome it.',
    createdAt: '2024-12-01',
    isPremium: false
  },
  {
    id: '242',
    title: 'Claustrophobia & Mask Desensitization',
    category: 'Treatment Adaptation',
    description: 'Overcoming claustrophobic reactions to CPAP masks with gradual desensitization techniques.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1515894203077-9cd36032142f?w=800&q=80',
    content: 'Claustrophobia is one of the most common reasons people struggle with CPAP masks. Learn proven desensitization techniques.',
    createdAt: '2024-12-01',
    isPremium: false
  },
  {
    id: '243',
    title: 'Breathing Exercises Before Sleep',
    category: 'Treatment Adaptation',
    description: 'Relaxation breathing techniques to reduce anxiety and improve CPAP comfort.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80',
    content: 'Breathing exercises before sleep can significantly improve CPAP comfort and therapy success.',
    createdAt: '2024-12-01',
    isPremium: false
  },
  {
    id: '244',
    title: 'Cognitive Strategies for CPAP Acceptance',
    category: 'Treatment Adaptation',
    description: 'Mental techniques to change unhelpful thoughts and build a positive CPAP mindset.',
    videoUrl: '',
    imageUrl: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=800&q=80',
    content: 'Your thoughts about CPAP therapy directly impact your success. Learn cognitive strategies for acceptance.',
    createdAt: '2024-12-01',
    isPremium: false
  }
];

export const mockCategories = [
  { id: '1', name: 'Sleep Disorders', count: 25 },  // +2: DSPS, ASPS
  { id: '2', name: 'Sleep Health', count: 11 },
  { id: '3', name: 'Treatments', count: 16 },  // +8: Melatonin, Magnesium, Ashwagandha, Valerian, OTC, Rx, Tapering
  { id: '4', name: 'Diagnosis', count: 18 },
  { id: '5', name: 'Treatment Devices', count: 14 },
  { id: '6', name: 'Sleep Science', count: 15 },
  { id: '7', name: 'Symptoms', count: 17 },  // +10: Sleep Inertia, Fatigue, Tired, Headaches, Sweats, Jerks, Dreams, Gasping, Circles, Racing
  { id: '8', name: 'Complications', count: 3 },
  { id: '9', name: 'Women\'s Health', count: 4 },
  { id: '10', name: 'Pediatric Sleep', count: 11 },
  { id: '11', name: 'Device Maintenance', count: 1 },
  { id: '12', name: 'Parasomnias', count: 8 },  // +2: Eating Disorder, Exploding Head
  { id: '13', name: 'Lifestyle & Sleep', count: 18 },  // +1: Sleepy Girl Mocktail
  { id: '14', name: 'Neuroscience Fundamentals', count: 1 },
  { id: '15', name: 'Sleep Technologies', count: 8 },
  { id: '16', name: 'Aging & Brain Health', count: 7 },
  { id: '17', name: 'Clinical Controversies', count: 30 },  // Debate-format topics
  { id: '18', name: 'Sleep & Performance', count: 1 },
  { id: '19', name: 'Cultural & Historical', count: 3 },
  { id: '20', name: 'Sleep Disorders Deep Dive', count: 5 },
  { id: '21', name: 'CPAP Equipment', count: 5 },
  { id: '22', name: 'Manufacturer Guides', count: 3 },
  { id: '23', name: 'Treatment Adaptation', count: 5 }
];

export const mockAdminUser = {
  email: 'emparis.quinones@gmail.com',
  password: 'CamryTRD1@'
};